import React, { PureComponent } from 'react'
import './style/home.less'
export default class Home extends PureComponent {

  constructor () {
    super()
    this.state = {
    }
  }
  render () {
    return (
      <div className = "Home">
        <span>慧途科技，商城平台端。</span>
      </div>
    )
  }
}
  